import {
  fetchDashboardStatisticsAPI,
  fetchStatisticsByReferenceAPI,
} from "../infrastructure/statistics.api";
import type { Statistics } from "../infrastructure/statistics.formatter";

export function fetchStatisticsByReference(
  tableId: number,
  options?: {
    startedAt: string;
    endedAt: string;
  },
  page?: number,
): Promise<Statistics> {
  return fetchStatisticsByReferenceAPI(tableId, options, page);
}

export function fetchDashboardStatistics(): Promise<Statistics> {
  return fetchDashboardStatisticsAPI();
}
